.s-offer-wrapper .s-slider-block__title {
  h2 {
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: #f87171;

    &::before {
      font-family: "sallaicons";
      content: "\ee30" !important;
      position: absolute;
      top: 1rem;
      font-size: 3rem;
      font-weight: 400;
      line-height: 1;
      color: #fef2f2;
    }
  }
}

.s-offer-bank-wrapper-sinlge-item{
    display: flex;
    align-items: center !important;
    gap: 14px;
}

.s-offer-bank-wrapper {
  display: flex !important;
  width: 100% !important;
}

// .s-offer-bank-wrapper {
  // 
// }